import React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { ChooseWithdrawalMethod } from '@/feature/withdraw/screens/ChooseWithdrawalMethod';
import { FailedMultipleWithdrawal } from '@/feature/withdraw/screens/FailedMultipleWithdrawal';
import { FailedWithdrawal } from '@/feature/withdraw/screens/FailedWithdrawal';
import { RedeemToFantasyForm } from '@/feature/withdraw/screens/RedeemToFantasyForm';
import { SuccessfulWithdrawal } from '@/feature/withdraw/screens/SuccessfulWithdrawal';
import { WithdrawFormView } from '@/feature/withdraw/screens/WithdrawForm';
import { WithdrawalExpiryUpdate } from '@/feature/withdraw/screens/WithdrawalExpiryUpdate';
import { WithdrawStackParamList } from '@/navigation/types';
import { common } from '@/styles/styles';

import { screenPresets } from '../screen-presets';

const Stack = createNativeStackNavigator<WithdrawStackParamList>();

export const WithdrawStack = () => (
    <SafeAreaProvider style={common.flex}>
        <Stack.Navigator screenOptions={screenPresets.modalStack}>
            <Stack.Screen name="ChooseWithdrawalMethod" component={ChooseWithdrawalMethod} />
            <Stack.Screen name="WithdrawForm" component={WithdrawFormView} />
            <Stack.Screen name="RedeemToFantasyFormScreen" component={RedeemToFantasyForm} />
            <Stack.Screen
                name="WithdrawalExpiryUpdate"
                component={WithdrawalExpiryUpdate}
                options={screenPresets.gestureDisabled}
            />
            <Stack.Screen
                name="SuccessfulWithdrawal"
                component={SuccessfulWithdrawal}
                options={screenPresets.gestureDisabled}
            />
            <Stack.Screen
                name="FailedWithdrawal"
                component={FailedWithdrawal}
                options={screenPresets.gestureDisabled}
            />
            <Stack.Screen
                name="FailedMultipleWithdrawal"
                component={FailedMultipleWithdrawal}
                options={screenPresets.gestureDisabled}
            />
        </Stack.Navigator>
    </SafeAreaProvider>
);
